import React, { useContext, useEffect, useState } from "react";
import Loader from "../../../Loader";
import Select from "react-select/creatable";
import classes from "./VendorMaster.module.css";
import Modal from "../../../Shared/PopupModal/PopupModal";
import { Urls } from "../../../../Urls";
import axios from "../../../../Axios/Axios";
import {
  DeleteMastersApi,
  findChangedValues,
  saveMastersApi,
  MastersChangeLog,
} from "../../Utility";
import Autosuggestor from "../../../Indent/AutoComplete";
import { toast } from "react-toastify";
import _ from "lodash";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import ShowHistory from "../../../Planning/components/ShowHistory";
import Pagination from "react-js-pagination";
import DownloadMastersButton from "../Utility/DownloadMastersButton";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { isSuperUser } from "../FreightMaster/UploadExcel/Step1/utils";
import { sendMailToMasters } from "../Utility/utility";
import { EditableEmailsContext } from "../../../../Context/EditableEmailsContext";
import MultiSelectFilterUI from "../../../Shared/newfilterui/MultiSelectFilterUI";

const TransporterGroupList = ({ group = [] }) => {
  return (
    <div
      style={{
        gap: "4px",
        overflowY: "auto",
        maxHeight: "50vh",
      }}
      className="d-flex flex-column justify-content-center px-3"
    >
      {group.map((item, index) => (
        <div key={index}>
          {index + 1}. {item}
        </div>
      ))}
    </div>
  );
};


/**
 * VendorMaster Component
 *
 * @returns {JSX.Element}
 */
const VendorMaster = ({ canedit = true, canAccess, canUpdate, checkActionPermission }) => {
  const [show, setShow] = useState(false);
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const [transporterList, setTransporterList] = useState([]);
  const [selectedGrp, setSelectedGrp] = useState("");
  const { companyProfile, userDetails } = useContext(UserApiContext);
  const [company_id, setcompany_id] = useState("");
  const [searchText, setSearchText] = useState();
  const [newTransporter, setNewTransporter] = useState({});
  const [deletion_list, setDeletion_list] = useState([]);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [isOrgLevel, setIsOrgLevel] = useState(false);
  const [skipactive, setSkipactive] = useState(0);
  const [totalcount, settotalcount] = useState(0);
  const [downloadData, setDownloadData] = useState([]);
  const { companySettingData, fetchCompanyProfileDetails } = useContext(
    MyCompanyProfileContext
  );
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [filtersshown, setfiltershown] = useState(false);

  const DEFAULT_SORT_OPTIONS = [
    { value: "transporter_name", label: "Vendor Name" },
    { value: "vendor_code", label: "Vendor Code" },
    { value: "credit_term", label: "Credit Term" },
  ];

  const [superAdmins, setSuperAdmins] = useState([])
  const [emailTemplate,setEmailTemplate] = useState({
          from:'',
          content:'',
          subject:'',
          cc:[],
          description:''
        })
  
  const emailData = useContext(EditableEmailsContext);
  
  useEffect(()=>{
    if(emailData && emailData?.notifyEmailForMastersUpdate){
      setEmailTemplate({
        content:emailData?.notifyEmailForMastersUpdate?.content,
        subject: emailData?.notifyEmailForMastersUpdate?.subject,
        cc: emailData?.notifyEmailForMastersUpdate?.cc || "connect@logisticsnow.in",
        from: emailData?.notifyEmailForMastersUpdate?.from,
        description: emailData?.notifyEmailForMastersUpdate?.email_description
      })
    }
  },[emailData])
  
  useEffect(()=>{
      if(companySettingData && companySettingData?.contact_information && companySettingData?.contact_information?.length > 0){
        const superAdminEmails = companySettingData?.contact_information?.filter((t)=>t?.super_admin===true)?.map((m)=>{
          return {
            name:m?.name,
            email:m?.email
          }
        })
        if(superAdminEmails && superAdminEmails?.length > 0 ){
          setSuperAdmins(superAdminEmails)
        }else{
          setSuperAdmins([])
        }
      }else{
        setSuperAdmins([])
      }
  },[companySettingData])

  const [selectedOrg, setSelectedOrg] = useState("company");
  const [orgList, setOrgList] = useState([]);
  useEffect(() => {
    if (companySettingData && companySettingData?.vendor_groups) {
      if (companySettingData?.vendor_groups?.length > 0) {
        const grpArr = companySettingData?.vendor_groups?.map((i) => {
          return {
            value: i,
            label: i,
          };
        });
        setDropDownOptions(grpArr);
      } else {
        setDropDownOptions([]);
      }
    } else {
      setDropDownOptions([]);
    }
  }, [companySettingData?.vendor_groups]);

  /**
   * Fetches and sets the list of vendors based on the current company ID and pagination.
   */
  const buildDefaultPayload = (skip = 0, limit = 500) => ({
    filter_opertaion: "and",
    date_range: [],
    filters: [],
    search: "",
    sort: { key: "transporter_name", order: "asc" },
    pagination: { skip, limit },
  });


  const getVendorData = (payload, orgId, showToast = false) => {
    setShow(true);
    const org = orgId || selectedOrg;
    const orgParam = org && org !== "company" ? `&organization_id=${org}` : "";
    const url = `${Urls.companyMaster}?master_type=vendor&action=fetch_masters_data${orgParam}`;
    axios
      .post(url, payload)
          .then((res) => {
            let count = 0;
            if (res.data && res.data.master_details) {
              setTransporterList(res.data.master_details);
              settotalcount(res.data.total);
              count = res.data.total;
            } else if (res.data && Array.isArray(res.data)) {
              setTransporterList(res.data);
              settotalcount(res.data.length);
              count = res.data.length;
            }
            if (showToast) {
              toast.success(`Found ${count} results`);
            }
            setShow(false);
          })
          .catch((err) => {
            console.log(err);
            if (showToast) {
              toast.error("Failed to apply filters");
            }
            setShow(false);
          });
      };

      useEffect(() => {
        if (companyProfile && userDetails) {
          if (companyProfile.domain_data && companyProfile.domain_data.company_id) {
            var id = companyProfile.domain_data.company_id;
            setcompany_id(id);
            getVendorData(buildDefaultPayload(0, 500), selectedOrg);
      }
    }
  }, [companyProfile, userDetails, selectedOrg]);

  useEffect(() => {
    if (companySettingData && companySettingData.contact_information) {
      const result = isSuperUser(companySettingData.contact_information);
      if (result) {
        if (result.organizationList && result.organizationList.length > 0) {
          setOrgList(result.organizationList);
        }
      }
    }
    if (companySettingData && companySettingData.masters_setting) {
      if (
        companySettingData.masters_setting.masters_show_level &&
        companySettingData.masters_setting.masters_show_level ===
          "organization_level"
      ) {
        setIsOrgLevel(true);
      }
    }
  }, [companySettingData]);

  /**
   * Handles the deletion of a single vendor.
   * @param {Event} e - click event.
   * @param {Object} item - vendor to delete.
   */
  const deleteHandler = (e, item) => {
    if (window.confirm("Are you sure you want to delete vendor?")) {
      setShow(true);
      DeleteMastersApi(company_id, "vendor", [item], selectedOrg, TrackMixPanel)
        .then((res) => {
          setShow(false);
          var temp = transporterList;
          var list = [];
          if (temp && temp.length > 0) {
            temp.map((data) => {
              if (data !== item) {
                list.push(data);
              }
            });
          }
          var activity = [
            {
              transporter_name: item.transporter_name,
              transporter_id: item.transporter_id,
              transporter_code: item.transporter_code,
              credit_term: item.credit_term,
              group: item.group,
            },
          ];

          sendMailToMasters("Vendor Master",emailTemplate,
            superAdmins,
            {
            action: "Vendor Deleted",
            lane:item,  
            },
            setShow,userDetails?.user_name || userDetails?.email?.split("@")[0]
          )

          MastersChangeLog(
            "Line Item Deleted",
            "vendor_master",
            userDetails.email,
            userDetails.user_id,
            company_id,
            activity,
            ""
          );
          TrackMixPanel({
            ModuleName: "masters",
            ScreenName: "vendor master",
            Definition: "user has clicked on vendor master delete button",
            Data: JSON.stringify({
              transporter_name: item?.transporter_name || "none",
              vendor_code: item?.vendor_code || "none",
              credit_term: item?.credit_term || "none",
              group: item?.group || "none",
            }),
          });
          toast.success("Deleted successfully");
          setTransporterList(list);
          if (list.length === 0) {
            setSkipactive(0);
          }
        })
        .catch((error) => {
          TrackMixPanel({
            ModuleName: "masters",
            ScreenName: "vendor master",
            Definition: "vendor master delete failed",
            Data: JSON.stringify({
              transporter_name: item?.transporter_name || "none",
              vendor_code: item?.vendor_code || "none",
              error: error.message,
            }),
          });
          console.log(error);
          setShow(false);
        });
    }
  };

  /**
   * Handles the selection or deselection of all vendors.
   * @param {Event} e - change event from the checkbox.
   */
  const selectAllHandler = (e) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      if (transporterList && transporterList.length > 0) {
        transporterList.map((item) => {
          if (!deletion_list.includes(item)) {
            list.push(item);
          }
        });
        setDeletion_list(list);
      }
    } else {
      setDeletion_list([]);
    }
  };

  /**
   * Handles the selection or deselection of vendors for deletion.
   * @param {Event} e - change event from the checkbox.
   * @param {Object} item - vendor item to select or deselect.
   */
  const checkboxeshandler = (e, item) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      list.push(item);
      setDeletion_list(list);
    } else {
      var temp = deletion_list.filter((value) => {
        return value !== item; // Return true or false based on the condition
      });
      setDeletion_list(temp);
    }
  };

  /**
   * Component for editing a vendor's details.
   *
   * @param {Object} transporter - transporter object to edit.
   * @param {number} index - index of the transporter in the list.
   * @param {Array<Object>} transporterList - list of all transporters.
   * @param {React.SetStateAction} setTransporterList - sets/updates list of transporters.
   * @returns {JSX.Element}
   */
  const EditVendorMaster = ({
    transporter,
    index,
    transporterList,
    superAdmins,
    emailTemplate,
    setTransporterList,
  }) => {
    const [searchText, setSearchText] = useState();
    const [updatedData, setUpdatedData] = useState({});
    const [grpArray, setGrpArray] = useState([]);

    useEffect(() => {
      if (transporter !== undefined) {
        var temp = _.cloneDeep(transporter);
        var newTemp = { ...temp, vendor_grp: [] };
        setUpdatedData(newTemp);
      }
    }, [transporter]);

    useEffect(() => {
      const arr =
        transporter?.group?.length > 0 &&
        transporter?.group?.map((i) => {
          return {
            label: i,
            value: i,
          };
        });
      setGrpArray(arr);
      setUpdatedData((prev) => ({
        ...prev,
        vendor_grp: arr,
      }));
    }, [transporter]);
    /**
     * Handles the save action for editing a vendor's details.
     * @param {Object} updatedData - updated vendor data.
     */
    const handleEdit = (updatedData) => {
      var grpString = [];
      if (updatedData?.vendor_grp?.length > 0) {
        grpString = updatedData?.vendor_grp?.map((i) => i?.value);
      } else {
        updatedData.vendor_grp = [];
        grpString = [];
      }
      updatedData.group = grpString;
      delete updatedData.vendor_grp;
      const sqlInjectionPatterns =
        /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;
      if (sqlInjectionPatterns.test(updatedData.transporter_name)) {
        toast.error("Please add valid transporter name");
      } else if (sqlInjectionPatterns.test(updatedData.vendor_code)) {
        toast.error("Please add valid transporter code");
      } else {
        setShow(true);
        const changedValues = findChangedValues(
          transporter,
          updatedData,
          "changed_value"
        );
        const previous_data = findChangedValues(
          transporter,
          changedValues,
          "original_value"
        );
        saveMastersApi(company_id, "vendor", [updatedData], selectedOrg, TrackMixPanel)
          .then((res) => {
            // console.log(res, 'res')

            sendMailToMasters("Vendor Master",emailTemplate,superAdmins,{
              action:"Vendor Edited",
              lane:updatedData
              }
            ,setShow,userDetails?.user_name || userDetails?.email?.split("@")[0])

            setShow(false);
            var temp = transporterList.map((editTransporter, idx) => {
              if (idx === index) {
                editTransporter = updatedData;
              }
              return editTransporter;
            });
            setTransporterList(temp);
            var activity = {
              transporter_name: updatedData.transporter_name,
              transporter_id: updatedData.transporter_id,
              existing_data: previous_data,
              updated_data: changedValues,
            };
            MastersChangeLog(
              "Line Item Updated",
              "vendor_master",
              userDetails.email,
              userDetails.user_id,
              company_id,
              activity,
              ""
            );
            TrackMixPanel({
              ModuleName: "masters",
              ScreenName: "vendor master",
              Definition: "user has clicked on vendor master save button",
              Data: JSON.stringify({
                transporter_name: updatedData?.transporter_name || "none",
                vendor_code: updatedData?.vendor_code || "none",
                credit_term: updatedData?.credit_term || "none",
                group: updatedData?.group || "none",
              }),
            });
            closeModal()
            toast.success("Details Edited Successfully");
            fetchCompanyProfileDetails()
          })
          .catch((error) => {
            console.log(error);
            setShow(false);
          });
      }
    };

    /**
     * Function to run on transporter select from suggestion
     * @param {any} e - select event
     * @returns {void} does not return anything
     */
    const addToTransporter = (e) => {
      if (
        transporterList.some((item) => item.transporter_id === e.transporter_id)
      ) {
        toast.info("Vendor already exist");
      } else {
        updatedData.logo = e.logo;
        updatedData.number_of_ratings = e.number_of_ratings;
        updatedData.overall_rating = e.overall_rating;
        updatedData.percentage_completion = e.percentage_completion;
        updatedData.transporter_id = e.transporter_id;
        updatedData.transporter_name = e.transporter_name;
      }
    };

    return (
      <>
        <div className={`row m-0`}>
          <div className={"col-md-4"}>
            <span style={{ fontWeight: "600" }}>Transporter/Vendor Name<span className="required-field"> *</span></span>
            <label style={{ width: "100%", pointerEvents: "none" }}>
              <Autosuggestor
                value={searchText}
                onChange={(e) => setSearchText(e)}
                onSelect={(e) => {
                  if (
                    transporterList.some((item) => item.transporter_name === e)
                  ) {
                    setSearchText(transporter.transporter_name);
                  } else {
                    setSearchText(e);
                  }
                }}
                getResults={(e) => addToTransporter(e)}
                placeholder={transporter.transporter_name}
              />
            </label>
          </div>
          <div className="col-3">
            <span style={{ fontWeight: "600" }}>Transporter/Vendor Code <span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="text"
                style={{ height: "37px" }}
                placeholder="Enter Code"
                onChange={(e) => {
                  updatedData.vendor_code = e.target.value;
                }}
                defaultValue={transporter?.vendor_code}
              />
            </label>
          </div>
          <div className="col-3">
            <span style={{ fontWeight: "600" }}>Credit term (in days) <span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="text"
                style={{ height: "37px" }}
                placeholder="Enter Credit Term"
                onChange={(e) => {
                  updatedData.credit_term = Number(e.target.value);
                }}
                defaultValue={transporter?.credit_term}
              />
            </label>
          </div>
          <div className="mx-2" style={{ width: "300px" }}>
            <span style={{ fontWeight: "600" }}>Vendor Group</span>
            <Select
              options={dropDownOptions}
              isMulti={true}
              value={updatedData.vendor_grp || []}
              onChange={(e) => {
                setUpdatedData((prev) => ({
                  ...prev,
                  vendor_grp: e,
                }));
              }}
              placeholder="Select/Create Groups"
            />
          </div>
        </div>
        <div className={`text-center`}>
          <button
            className={`${classes["save-btn"]} btn btn-success`}
            onClick={() => handleEdit(updatedData)}
          >
            Save Changes
          </button>
        </div>
      </>
    );
  };

  /**
   * Handles saving a new vendor. Performs validation to check for SQL injection and required fields.
   * If the vendor does not already exist, it will be added to the list and saved via API.
   *
   * @returns {void}
   */
  const handleSave = () => {
    var group = [];
    if (newTransporter?.vendor_grp?.length > 0) {
      newTransporter.vendor_grp.map((item) => {
        group.push(item.value);
      });
    }
    const sqlInjectionPatterns =
      /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;
    if (
      !newTransporter ||
      newTransporter === undefined ||
      sqlInjectionPatterns.test(newTransporter) ||
      newTransporter.transporter_id === undefined
    ) {
      toast.error("Please add Vendor");
    } else if (
      sqlInjectionPatterns.test(newTransporter.vendor_code) ||
      newTransporter.vendor_code === undefined ||
      newTransporter.vendor_code === ""
    ) {
      toast.error("Please add vendor code");
    } else if (
      sqlInjectionPatterns.test(newTransporter.credit_term) ||
      newTransporter.credit_term === undefined ||
      newTransporter.credit_term === ""
    ) {
      toast.error("Please add credit terms");
    } else {
      newTransporter["group"] = group;
      setShow(true);
      if (Array.isArray(transporterList) && newTransporter) {
        if (
          !transporterList.some(
            (item) => item.transporter_id === newTransporter.transporter_id
          ) ||
          transporterList.length === 0
        ) {
          delete newTransporter.vendor_grp;
          delete newTransporter.contact_information;
          saveMastersApi(company_id, "vendor", [newTransporter], selectedOrg, TrackMixPanel)
            .then((res) => {
              setShow(false);
              if (transporterList) {
                const prevList = transporterList.concat(newTransporter);
                setTransporterList(prevList);
              } else {
                setTransporterList(newTransporter);
              }

              sendMailToMasters("Vendor Master",emailTemplate,superAdmins,{
              action:"New Vendor Added",
              lane:newTransporter
              }
              ,setShow,
              userDetails?.user_name || userDetails?.email?.split("@")[0]
              )
              var activity = {
                transporter_name: newTransporter.transporter_name,
                transporter_id: newTransporter.transporter_id,
                transporter_code: newTransporter.transporter_code,
                credit_term: newTransporter.credit_term,
                group: newTransporter.group,
              };
              MastersChangeLog(
                "Line Item Added",
                "vendor_master",
                userDetails.email,
                userDetails.user_id,
                company_id,
                activity,
                ""
              );
              TrackMixPanel({
                ModuleName: "masters",
                ScreenName: "vendor master",
                Definition: "user has clicked on add details vendor master button",
                Data: JSON.stringify({
                  transporter_name: newTransporter?.transporter_name || "none",
                  vendor_code: newTransporter?.vendor_code || "none",
                  credit_term: newTransporter?.credit_term || "none",
                  group: newTransporter?.group || "none",
                }),
              });
              toast.success("Vendor Added Successfully");
              setNewTransporter();
              setSearchText();
              fetchCompanyProfileDetails();
              setShow(false);
              const closeBtn = document.getElementById("close_addVendorMaster");
              if (closeBtn) closeBtn.click();

            })
            .catch((error) => {
              console.log(error);
              setShow(false);
            });
        } else {
          toast.info("Vendor already exists");
        }
      } else {
        toast.info("Please add Vendor");
      }
    }
  };

  /**
   * Deletes selected vendors from the list.
   *
   * @param {Event} e - click event.
   * @returns {void}
   */
  const deleteLanes = (e) => {
    if (deletion_list && deletion_list.length > 0) {
      if (window.confirm("Are you sure to delete?")) {
        setShow(true);
        var payload = {
          data: deletion_list,
        };

        axios
          .post(
            `${Urls.companyMaster}?company_id=${companyProfile.domain_data.company_id}&master_type=vendor&status=deleted`,
            payload
          )
          .then((res) => {
            sendMailToMasters(
                "Vendor Master",
                emailTemplate,
                superAdmins,
                {
                action: `Multiple Item(s) Deleted`,
                lane: '',
                },
                setShow,
                userDetails?.user_name || userDetails?.email?.split("@")[0]
            );
            TrackMixPanel({
              ModuleName: "masters",
              ScreenName: "vendor master",
              Definition: "user has clicked on vendor master bulk delete button",
              Data: JSON.stringify({
                deleted_count: deletion_list.length,
                vendor_codes: deletion_list.map((deletedLane) => deletedLane.vendor_code),
              }),
            });
            toast.success("Lanes deleted successfully");
            const updatedList = transporterList.filter(
              (truck) =>
                !deletion_list.some((deletedLane) => deletedLane === truck)
            );
            setTransporterList(updatedList);
            setShow(false);
            setDeletion_list([]);
          })
          .catch((err) => {
            console.log(err);
            setShow(false);
          });
      }
    } else {
      toast.error("Please Select atleast 1 item");
      return false;
    }
  };

  const handleFilterApply = (payload, showToast = true) => {
    setIsFilterLoading(true);
    setIsFilterActive(true);
    setFilterPayload(payload);

    if (payload?.pagination?.skip === 0) {
      setSkipactive(0);
    }

    getVendorData(payload, selectedOrg, showToast);
    setIsFilterLoading(false);
  };

  const handleFilterReset = () => {
    setIsFilterActive(false);
    setFilterPayload(null);
    setSkipactive(0);
    getVendorData(buildDefaultPayload(0, 500), selectedOrg);
    toast.info("Filters reset");
  };

  const ActiveFilterPills = () => {
    if (!isFilterActive || !filterPayload) return null;

    const hasFilters =
      filterPayload.filters && filterPayload.filters.length > 0;
    const hasSearch =
      filterPayload.search && filterPayload.search.trim() !== "";

    const currentSortKey = filterPayload.sort?.key;
    const isDefaultSort = currentSortKey === "transporter_name" || !currentSortKey;
    const currentSortLabel =
      DEFAULT_SORT_OPTIONS.find((o) => o.value === currentSortKey)?.label ||
      currentSortKey;
    const hasSort = !isDefaultSort;

    const currentLimit = filterPayload.pagination?.limit;
    const hasPagination = currentLimit && currentLimit !== 500;

    if (!hasFilters && !hasSearch && !hasSort && !hasPagination) return null;

    const removeFilter = (filterKey) => {
      const updatedFilters = filterPayload.filters.filter(
        (f) => f.key !== filterKey
      );
      if (
        updatedFilters.length === 0 &&
        (!filterPayload.search || filterPayload.search.trim() === "") &&
        !hasSort &&
        !hasPagination
      ) {
        handleFilterReset();
      } else {
        const updated = {
          ...filterPayload,
          filters: updatedFilters,
          pagination: { ...filterPayload.pagination, skip: 0 },
        };
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const clearSearch = () => {
      const updated = {
        ...filterPayload,
        search: "",
        pagination: { ...filterPayload.pagination, skip: 0 },
      };
      if (!hasFilters && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const resetSort = () => {
      const updated = {
        ...filterPayload,
        sort: { key: "transporter_name", order: "asc" },
        pagination: { ...filterPayload.pagination, skip: 0 },
      };
      if (!hasFilters && !hasSearch && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const resetPagination = () => {
      const updated = {
        ...filterPayload,
        pagination: { ...filterPayload.pagination, limit: 500, skip: 0 },
      };
      if (!hasFilters && !hasSearch && !hasSort) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const formatValue = (value) =>
      Array.isArray(value) ? value.join(", ") : value;

    return (
      <div className={classes["active-filters-area"]}>
        <div className={classes["filter-header"]}>
          <i className="fa fa-filter mr-2 text-primary" style={{ fontSize: "14px" }} />
          <span className={classes["filter-header-text"]}>Active Filters</span>
        </div>

        <div className={classes["filter-content"]}>
          {hasSearch && (
            <div className={classes["filter-pill"]}>
              <span className={classes["filter-pill-text"]}>
                <i className="fa fa-search mr-1 text-info" style={{ fontSize: "10px" }} />
                <strong className="mr-1">Search:</strong> {filterPayload.search}
              </span>
              <i
                className={`fa fa-times ${classes["filter-pill-close"]} ml-2 text-danger`}
                onClick={clearSearch}
              />
            </div>
          )}

          {filterPayload.filters?.map((f, i) => (
            <div key={`${f.key}_${i}`} className={classes["filter-pill"]}>
              <span className={classes["filter-pill-text"]}>
                <i className="fa fa-check-circle mr-1 text-success" style={{ fontSize: "10px" }} />
                <strong className="mr-1">{f.label || f.key}:</strong>{" "}
                {formatValue(f.values)}
              </span>
              <i
                className={`fa fa-times ${classes["filter-pill-close"]} ml-2 text-danger`}
                onClick={() => removeFilter(f.key)}
              />
            </div>
          ))}

          {hasSort && (
            <div className={classes["filter-pill"]}>
              <span className={classes["filter-pill-text"]}>
                <i className="fa fa-sort mr-1 text-warning" style={{ fontSize: "10px" }} />
                <strong className="mr-1">Sort:</strong> {currentSortLabel}
              </span>
              <i
                className={`fa fa-times ${classes["filter-pill-close"]} ml-2 text-danger`}
                onClick={resetSort}
              />
            </div>
          )}

          {hasPagination && (
            <div className={classes["filter-pill"]}>
              <span className={classes["filter-pill-text"]}>
                <i className="fa fa-list-ol mr-1" style={{ fontSize: "10px" }} />
                <strong className="mr-1">Limit:</strong> {currentLimit}
              </span>
              <i
                className={`fa fa-times ${classes["filter-pill-close"]} ml-2 text-danger`}
                onClick={resetPagination}
              />
            </div>
          )}
        </div>

        <button
          className={`btn btn-sm btn-link text-danger ${classes["clear-all-btn"]}`}
          onClick={handleFilterReset}
        >
          Clear All
        </button>
      </div>
    );
  };

  /**
   * Handles pagination change for vendors.
   * @param {number} e - page number.
   * @returns {void}
   */
  const getOnChange = (e) => {
    setSkipactive(e);
    if (isFilterActive && filterPayload) {
      const currentLimit = filterPayload?.pagination?.limit || 500;
      const dynamicSkip = (e - 1) * currentLimit;
      const updated = {
        ...filterPayload,
        pagination: {
          ...filterPayload.pagination,
          skip: dynamicSkip,
          limit: currentLimit,
        },
      };
      setFilterPayload(updated);
      getVendorData(updated, selectedOrg);
    } else {
      const calculatedSkip = (e - 1) * 500;
      getVendorData(buildDefaultPayload(calculatedSkip, 500), selectedOrg);
    }
  };

  const handleInputChange = (event, type) => {
    setNewTransporter({
      ...newTransporter,
      [type]: event.target.value,
    });
  };

  const deleteGrpHandler = async () => {
    if (selectedGrp === "" || !selectedGrp) {
      toast.error("Please select group to Delete");
      return;
    }
    const payload = {
      operation: "delete",
      group_name: selectedGrp,
    };
    try {
      setShow(true);
      const uri = `${Urls.companyMaster}?master_type=vendor&company_id=${companyProfile?.domain_data?.company_id}`;
      const { data } = await axios.post(uri, payload);
      sendMailToMasters("Vendor Master",emailTemplate,
          superAdmins,
        {
        action: "Vendor Group Deleted",
        lane:selectedGrp,
        },
        setShow,userDetails?.user_name || userDetails?.email?.split("@")[0]
      );
      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "vendor master",
        Definition: "user has deleted vendor group",
        Data: JSON.stringify({ group_name: selectedGrp }),
      });
      fetchCompanyProfileDetails();
      setSelectedGrp("");
      toast.success("Group deleted successfully");
      getVendorData(buildDefaultPayload(0, 500), selectedOrg);
    } catch (error) {
      console.log(error);
      setShow(false);
    } finally {
      setShow(false);
    }
  };

  const EditVendorGroup = ({ selectedGrp, emailTemplate, superAdmins }) => {
    const [editGrp, setEditGrp] = useState("");

    const editGrphandler = async () => {
      if (selectedGrp === "" || !selectedGrp) {
        toast.error("Please select group to Edit");
        return;
      }

      if (editGrp === "" || !editGrp) {
        toast.error("Please enter new group name");
        return;
      }
      if (editGrp === selectedGrp) {
        toast.error("Please enter different group name");
        return;
      }
      if (dropDownOptions && dropDownOptions?.length > 0) {
        const findGrp = dropDownOptions?.find((d) => d?.value === editGrp);
        if (findGrp) {
          toast.error("Group name already exists");
          return;
        }
      }
      try {
        setShow(true);
        const uri = `${Urls.companyMaster}?master_type=vendor&company_id=${companyProfile?.domain_data?.company_id}`;
        const payload = {
          operation: "rename",
          old_name: selectedGrp,
          new_name: editGrp,
        };
        
        sendMailToMasters("Vendor Master",emailTemplate,
          superAdmins,
        {
        action: "Vendor Group Edited",
        lane:{
          old_name: selectedGrp,
          new_name: editGrp
        }
        },
        setShow,userDetails?.user_name || userDetails?.email?.split("@")[0])

        const { data } = await axios.post(uri, payload);
        setSelectedGrp("");
        setEditGrp("");
        toast.success("Group name edited successfully");
        getVendorData(buildDefaultPayload(0, 500), selectedOrg);
        closeModal();
      } catch (error) {
        console.log(error);
        setShow(false);
      } finally {
        setShow(false);
      }
    };
    return (
      <div>
        <label>Old Group Name:</label>
        <input
          type="text"
          disabled={true}
          className="mb-2"
          value={selectedGrp}
        />
        {(selectedGrp === "" || !selectedGrp) && (
          <p className="text-danger">Please select a group first</p>
        )}
        <label>New Group Name:</label>
        <input
          type="text"
          className="mb-3"
          value={editGrp}
          onChange={(e) => setEditGrp(e.target.value)}
        />
        <button
          className="btn btn-primary"
          onClick={() => {
            editGrphandler();
          }}
        >
          Save
        </button>
      </div>
    );
  };

  const closeModal = () => {
    const btnRef = document.getElementById("close_contactus");
    if (btnRef) {
      btnRef.click()
    }
  };

  return (
    <div className="mt-3 mx-5 my-3">
      <div>
        <Loader show={show} />

        {filtersshown && (
          <div className="mt-4 mb-4">
            <MultiSelectFilterUI
              module="VendorMaster"
              action="filterable_fields"
              filterBaseUrl={Urls.planning_master_filters}
              uniqueValuesMasterType="vendor"
              defaultFields={[
                { key: "transporter_name", label: "Vendor Name", type: "text" },
                { key: "vendor_code", label: "Vendor Code", type: "text" },
                { key: "credit_term", label: "Credit Term", type: "number" },
                { key: "group", label: "Groups", type: "enum" },
              ]}
              defaultSortOptions={DEFAULT_SORT_OPTIONS}
              onFilterApply={handleFilterApply}
              onReset={handleFilterReset}
              initialPayload={filterPayload}
              isLoading={isFilterLoading || show}
              onClose={() => setfiltershown(false)}
              showSearch={false}
            />
          </div>
        )}
        {/* <div className={`row justify-content-end mb-2 mt-0`}> */}
        <div
          style={{
            position: "absolute",
            marginTop: "-48px",
            marginBottom: "25px",
            right: "10%",
            display: "flex",
          }}
        >
          {isOrgLevel === true && (
            <select
              className="form-control mr-2"
              style={{ maxWidth: "max-content" }}
              value={selectedOrg}
              onChange={(e) => setSelectedOrg(e.target.value)}
            >
              <option value={"company"} selected>
                Company
              </option>
              {orgList &&
                orgList.length > 0 &&
                orgList.map((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  );
                })}
            </select>
          )}
          <Modal
            id="upload-modal"
            showLogo={true}
            title="Activity Log for Masters"
            buttonLabel={
              <>
                <i
                  className="far fa-clock pr-2"
                  style={{ fontSize: "15px" }}
                ></i>
                <span>Show Activity</span>
              </>
            }
            buttonClass={`btn btn-info mr-2`}
            style={{}}
            disabled={canedit || !canUpdate}
            content={<ShowHistory screen_name="vendor_master" />}
            screenName="Vendor Master"
            moduleName="Vendor Master"
          />
        </div>
        <div className="d-flex align-items-center" style={{ gap: "10px", marginBottom: "15px" }}>
          <Modal
            buttonLabel={
              <>
                <i className="fa fa-plus pr-2" />
                Add Vendor Master
              </>
            }
            buttonClass="btn btn-primary"
            style={{ fontSize: "12px", backgroundColor: "#3f51b5", borderColor: "#3f51b5" }}
            disabled={canedit || !canUpdate}
            content={
              <div className="p-2">
                <div className="row m-0 mb-3">
                  <div className="col-md-6 pr-2">
                    <span style={{ fontWeight: "600", fontSize: "13px", whiteSpace: "nowrap" }}>
                      Transporter/Vendor Name <span className="required-field"> *</span>
                    </span>
                    <div className="border" style={{ position: "relative", minHeight: "37px" }}>
                      <Autosuggestor
                        value={searchText}
                        onChange={(e) => setSearchText(e)}
                        onSelect={(e) => setSearchText(e)}
                        getResults={(e) => setNewTransporter(e)}
                        disabled={canedit || !canUpdate}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 pl-2">
                    <span style={{ fontWeight: "600", fontSize: "13px", whiteSpace: "nowrap" }}>
                      Transporter/Vendor Code <span className="required-field"> *</span>
                    </span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input
                        type="text"
                        className="form-control"
                        style={{ height: "37px" }}
                        placeholder="Enter Code"
                        name="vendor_code"
                        value={newTransporter?.vendor_code ? newTransporter.vendor_code : ""}
                        onChange={(e) => handleInputChange(e, "vendor_code")}
                        disabled={canedit || !canUpdate}
                      />
                    </label>
                  </div>
                </div>
                <div className="row m-0 mb-3">
                  <div className="col-md-6 pr-2">
                    <span style={{ fontWeight: "600", fontSize: "13px", whiteSpace: "nowrap" }}>
                      Credit term (in days) <span className="required-field"> *</span>
                    </span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input
                        type="text"
                        className="form-control"
                        style={{ height: "37px" }}
                        name="credit_term"
                        placeholder="Enter Credit term"
                        value={newTransporter?.credit_term ? newTransporter.credit_term : ""}
                        onChange={(e) => handleInputChange(e, "credit_term")}
                        disabled={canedit || !canUpdate}
                      />
                    </label>
                  </div>
                  <div className="col-md-6 pl-2">
                    <span style={{ fontWeight: "600", fontSize: "13px", whiteSpace: "nowrap" }}>Vendor Group</span>
                    <Select
                      placeholder="Select/Create Groups"
                      options={dropDownOptions}
                      value={newTransporter?.vendor_grp ?? []}
                      isMulti={true}
                      onChange={(e) => {
                        setNewTransporter({
                          ...newTransporter,
                          vendor_grp: e,
                        });
                      }}
                      isDisabled={canedit || !canUpdate}
                    />
                  </div>
                </div>
                <div className="row m-0 justify-content-center mt-4 mb-2">
                  <button
                    className="btn btn-success px-4"
                    disabled={canedit || !canUpdate}
                    onClick={() => handleSave()}
                  >
                    Add Vendor Details
                  </button>
                </div>
              </div>
            }
            title={`Add Vendor Master`}
            id="addVendorMasterModal"
            closeButtonId="close_addVendorMaster"
            screenName="Vendor Master"
            moduleName="Vendor Master"
            backdrop={"static"}
            size="lg"
          />
          <button
            id="submitLane"
            disabled={deletion_list.length === 0 || canedit || !canUpdate}
            className={`btn btn-sm btn-danger ${superAdmin === false ? "btn-delete2" : "btn-delete1"}`}
            onClick={(e) => deleteLanes(e)}
          >
            <i className="fa fa-trash mr-2" />
            Delete
          </button>
          <DownloadMastersButton
            type="vendor"
            company_id={company_id}
            masterList={transporterList}
            totalCount={totalcount}
          />
          <button
            className={`btn btn-sm ${isFilterActive ? "btn-success" : "btn-primary"} ms-2`}
            onClick={() => setfiltershown(true)}
          >
            <i className={`fa ${isFilterActive ? "fa-check-circle" : "fa-filter"} pr-2`} />
            <span>{isFilterActive ? "Filters Applied" : "Filter"}</span>
          </button>
        </div>
      </div>
      <div
        style={{ gap: "10px" }}
        className="d-flex align-items-center w-100 mt-5"
      >
        <select
          style={{ maxWidth: "fit-content" }}
          className="form-control p-1"
          value={selectedGrp}
          onChange={(e) => setSelectedGrp(e.target.value)}
        >
          <option value="" disabled selected>
            Select Vendor Group to Edit/Delete
          </option>
          {dropDownOptions &&
            dropDownOptions?.length > 0 &&
            dropDownOptions?.map((i, index) => {
              return (
                <option key={index} value={i.value}>
                  {i.label}
                </option>
              );
            })}
        </select>
        <button
          className="btn btn-danger"
          style={{}}
          disabled={selectedGrp === "" || !selectedGrp || canedit || !canUpdate}
          onClick={() => deleteGrpHandler()}
        >
          Delete Vendor Groups
        </button>
        <Modal
          onClose={() => {
            fetchCompanyProfileDetails();
          }}
          style={{}}
          disabled={selectedGrp === "" || !selectedGrp || canedit || !canUpdate}
          id="editVendorGroupModal"
          buttonLabel={`Edit Vendor Group Name`}
          title={`Edit Vendor Group Name`}
          buttonClass={`btn btn-info mr-2`}
          content={<EditVendorGroup superAdmins={superAdmins} emailTemplate={emailTemplate} selectedGrp={selectedGrp} />}
          screenName="Vendor Master"
          moduleName="Vendor Master"
        />
      </div>
      <div className={`${classes["table-alignment"]} mt-3 mr-3 `}>
        <ActiveFilterPills />
        <table className={`${classes["table-width"]} table table-borderless`}>
          <thead>
            <tr style={{ fontSize: "14px" }}>
              <th className={`${classes["sticky-th"]} pl-4`}>
                <input
                  type="checkbox"
                  checked={
                    transporterList &&
                    transporterList.length > 0 &&
                    deletion_list.length === transporterList.length
                  }
                  onChange={selectAllHandler}
                  style={{ width: "15px", height: "15px" }}
                />
              </th>
              <th
                scope="col"
                className={`${classes["sticky-th"]}`}
                style={{ textAlign: "center" }}
              >
                Sr No.
              </th>
              <th
                scope="col"
                className={`${classes["sticky-th"]}`}
                style={{ textAlign: "center" }}
              >
                Transporter Name
              </th>
              <th
                scope="col"
                className={`${classes["sticky-th"]}`}
                style={{ textAlign: "center" }}
              >
                Transporter Code
              </th>
              <th
                scope="col"
                className={`${classes["sticky-th"]}`}
                style={{ textAlign: "center" }}
              >
                Credit Term
              </th>
              <th
                scope="col"
                className={`${classes["sticky-th"]}`}
                style={{ textAlign: "center" }}
              >
                Groups
              </th>
              <th
                scope="col"
                className={`${classes["sticky-th"]}`}
                style={{ textAlign: "center" }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {transporterList && transporterList.length > 0
              ? transporterList.map((transporter, index) => {
                  return (
                    <tr key={`${transporter.transporter_name}_${index}`}>
                      <td className={`${classes["borderforTd"]}`}>
                        <input
                          type="checkbox"
                          style={{
                            width: "15px",
                            height: "15px",
                            marginLeft: "8px",
                          }}
                          onChange={(e) => checkboxeshandler(e, transporter)}
                          checked={deletion_list.includes(transporter)}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>{index + 1}.</td>
                      <td style={{ textAlign: "center" }}>
                        {transporter.transporter_name}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {transporter.vendor_code}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {transporter.credit_term}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {transporter?.group?.length > 0 ? (
                          transporter?.group?.length > 2 ? (
                            <Modal
                              buttonClass={"btn btn-link"}
                              size="md"
                              buttonLabel={
                                <span>
                                  {transporter?.group?.slice(0, 2).join(", ")} +{" "}
                                  {transporter?.group?.length - 2} more
                                </span>
                              }
                              title={`Groups in which ${transporter?.transporter_name} belongs`}
                              content={
                                <TransporterGroupList group={transporter?.group} />
                              }
                            />
                          ) : (
                            transporter?.group?.join(", ")
                          )
                        ) : (
                          "-"
                        )}
                      </td>

                    <td className="text-center">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Modal
                            buttonLabel={<i className="fa fa-pencil text-dark" />}
                            buttonClass={`btn btn-link}`}
                            style={{}}
                            disabled={canedit || !canUpdate}
                            content={
                              <EditVendorMaster
                                superAdmins={superAdmins}
                                emailTemplate={emailTemplate}
                                transporter={transporter}
                                index={index}
                                transporterList={transporterList}
                                setTransporterList={setTransporterList}
                              />
                            }
                            title={`Edit Vendor Master`}
                            id="vendorMaster"
                            screenName="Vendor Master"
                            moduleName="Vendor Master"
                          />
                        <button
                          className="btn btn-link text-dark"
                          onClick={(e) => deleteHandler(e, transporter)}
                          style={{}}
                          disabled={canedit || !canUpdate}
                        >
                          <i className={`fa fa-trash`} aria-hidden="true" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
              : null}
          </tbody>
        </table>
        <div style={{ display: "none" }}>
          <table id="vendor_master_table">
            <thead>
              <tr>
                <th className={classes["col1"]} style={{ textAlign: "center" }}>
                  Sr No.
                </th>
                <th className={classes["col1"]} style={{ textAlign: "center" }}>
                  Transporter Name
                </th>
                <th className={classes["col1"]} style={{ textAlign: "center" }}>
                  Transporter Code
                </th>
                <th className={classes["col1"]} style={{ textAlign: "center" }}>
                  Credit Term
                </th>
                <th className={classes["col1"]} style={{ textAlign: "center" }}>
                  Group
                </th>
              </tr>
            </thead>
            <tbody>
              {downloadData && downloadData.length > 0
                ? downloadData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.transporter_name}</td>
                      <td>{item.vendor_code}</td>
                      <td>{item.credit_term}</td>
                      <td>
                        {item?.group?.length > 0
                          ? item?.group?.join(", ")
                          : "-"}
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
      <center>
        <Pagination
          activePage={skipactive === 0 ? 1 : skipactive}
          itemsCountPerPage={500}
          totalItemsCount={totalcount}
          onChange={(e) => getOnChange(e)}
          itemClass="page-item"
          linkClass="page-link"
          // hideDisabled
        />
      </center>
    </div>
  );
};

export default VendorMaster;